import Dispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import { ReduceStore } from 'flux/utils';


class AssetTypeStore extends ReduceStore {
    getInitialState() {
        return {
            isFetching: false,
            assetTypes: [],
        };
    }

    getById(id) {
        return this.getState().assetTypes.find(t => !!t && t.id === id);
    }

    getByName(name) {
        return this.getState().assetTypes.find(t => !!t && t.name === name);
    }

    isFetching() {
        return this.getState().isFetching;
    }

    getAll()  {
        return this.getState().assetTypes;
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.ASSETTYPE_LIST_REQUEST:
                return {...state, isFetching: true};

            case ActionTypes.ASSETTYPE_LIST_SUCCESS:
                return {...state, isFetching: false, assetTypes: action.data};

            case ActionTypes.ASSETTYPE_LIST_FAILURE:
                return {...state, isFetching: false};

            default:
                return state;
        }
    }
}

export default new AssetTypeStore(Dispatcher);
